import * as React from "react";
import * as ReactDOM from "react-dom";
import { InputBase, InputContainer, InputHint, IInputBaseProperties } from "../input";


interface IProperties
{
    /**
     * Enthält alle Child-Elemente.
     */
    children?: JSX.Element | JSX.Element[],

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Name des RadioButton.
     */
    name?: string,

    /**
     * Anzeigetext des RadioButton.
     */
    label?: string,

    /**
     * Setzt einen Hilfetext.
     */
    hint?: string | JSX.Element,

    /**
     * Gibt an ob der RadioButton ausgewählt ist.
     */
    isChecked?: boolean,

    /**
     * Ein Wert der angibt, ob der Wert des Inputs nur lesbar ist.
     */
    isReadOnly?: boolean,

    /**
     * Ein Wert der angibt, ob das Input abgeschaltet ist.
     */
    isDisabled?: boolean,

    /**
     * Wird ausgeführt, sobald sich der Wert der Checkbox ändert.
     */
    onCheckedChanged?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export class RadioButton extends React.Component<IProperties>
{
    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        var { style, children, name, label, hint, isChecked, isReadOnly, isDisabled, onCheckedChanged } = this.props;
        var className: string[] = ["radiobutton"];

        if (isDisabled)
            className.push("radiobutton--disabled");

        return (
            <InputContainer
                alignLeft
                style={{
                    marginBottom: 10,
                    ...style
                }}>
                <label
                    className={className.join(" ")}>
                    <span>{label}</span>
                    <input
                        type="radio"
                        name={name}
                        checked={isChecked}
                        onChange={onCheckedChanged}
                        readOnly={isReadOnly}
                        disabled={isDisabled} />
                    <div className="radiobutton_checkmark">
                        <div className="radiobutton_checkmark_bg"></div>
                    </div>
                </label>
                {
                    hint &&
                    <InputHint style={{
                        marginLeft: 28,
                    }}>
                        {hint}
                    </InputHint>
                }
            </InputContainer>
        );
    }
}